import React, {useState, useEffect, FC} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import type {Bundle, BundleVersion} from '@deviceinsight/ng-ui-api-client';
import {fetchBundleVersion} from '@deviceinsight/ng-ui-api-client';
import {fetchBundle} from '../../../api/updateJobsApi';
import {ADMIN_CREATE_TEST_IDS} from '../consts';
import './JobVariantDetails.less';
import BundleLink from '../../common/BundleLink';
import BundleVersionLink from '../../common/BundleVersionLink';
type Props = {
	bundleAndVersionData?: {
		bundleId: string;
		bundleVersionId: string;
	};
};

const JobVariantDetails: FC<Props> = ({bundleAndVersionData}) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [bundle, setBundle] = useState<Bundle | null | undefined>(undefined);
	const [version, setVersion] = useState<BundleVersion | null | undefined>(undefined);

	useEffect(() => {
		const promises = [];

		setLoading(true);

		if (bundleAndVersionData?.bundleId) {
			const bundlePromise = fetchBundle(bundleAndVersionData.bundleId).then(setBundle);
			promises.push(bundlePromise);
		}

		if (bundleAndVersionData?.bundleVersionId) {
			const versionPromise = fetchBundleVersion(
				bundleAndVersionData.bundleId,
				bundleAndVersionData.bundleVersionId
			).then(setVersion);
			promises.push(versionPromise);
		}

		Promise.all(promises).finally(() => setLoading(false));
	}, [bundleAndVersionData]);

	if (!bundleAndVersionData) {
		return (
			<div className="di job-variant-details">
				<em>
					<Trans i18nKey="updatejobs.details.noUpdate">No Update</Trans>
				</em>
			</div>
		);
	}

	return (
		<div className="di job-variant-details">
			<SpinnerContainer show={loading}>
				<div data-testid={ADMIN_CREATE_TEST_IDS.BUNDLE_SELECT} className="field bundle">
					<label>
						<Trans i18nKey="updatejobs.create.bundle">Bundle</Trans>
					</label>
					{bundle && <BundleLink bundleId={bundle.id}>{bundle.name}</BundleLink>}
				</div>
				<div data-testid={ADMIN_CREATE_TEST_IDS.BUNDLE_SELECT} className="field version">
					<label>
						<Trans i18nKey="updatejobs.create.version">Version</Trans>
					</label>
					{bundle && version && (
						<BundleVersionLink bundleId={bundle.id} versionId={version.id}>
							{version.name}
						</BundleVersionLink>
					)}
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default JobVariantDetails;
